import axios from 'api/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { extractData } from 'api/utils';
import { v2Url } from 'api/api-constants';
import { workOrderUrlPrefix, workOrderQueryKey } from './consts';

export function patchWorkOrder(payload) {
	return axios
		.patch(`${workOrderUrlPrefix}/${payload.id}`, payload, {
			baseURL: v2Url,
		})
		.then(extractData);
}

export function usePatchWorkOrder() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (payload: any) => patchWorkOrder(payload),
		onSuccess: () => {
			// Invalidate and refetch
			queryClient.invalidateQueries({
				queryKey: [workOrderQueryKey],
			});
		},
	});
}
